import React from "react";
import { StagingTitelineAppBreakdowns } from "../types/StagingTitelineAppBreakdowns";
import { ActivityAndBreakdownData } from "../types/ActivityAndBreakdownData";
import { getApiUrl } from '../config/api';

export const fetchBreakdownsByPid = async (pid: number, aid: number = -1): Promise<ActivityAndBreakdownData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineBreakdowns/GetBreakdownsByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            console.log("Failed to fetch breakdowns data by pid:", pid, "state:", response.status, response.statusText);
            return [];
        }

        let backendData: StagingTitelineAppBreakdowns[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((breakdown) => breakdown.DataSource === aid.toString());
        }

        const transformedData: ActivityAndBreakdownData[] = backendData.map((breakdowns) => ({
            key: breakdowns.Bid,
            aob_id: breakdowns.Bid,
            pid: breakdowns.Pid,
            hole_id: breakdowns.HoleID,
            aob_type: `BREAKDOWN:${breakdowns.Type}`,
            time_start: breakdowns.TimeStart,
            time_finish: breakdowns.TimeFinish,
            total_hours: breakdowns.Hours,
        }));

        return transformedData;
    } catch (error) {
        console.error("Error in fetchBreakdownsByPid API call:", error);
        return [];
    }
};

export const addBreakdownRow = async (breakdownRow: ActivityAndBreakdownData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineBreakdowns/AddBreakdowns');

    const cloudPayload = [{
        Pid: breakdownRow.pid ?? -1,
        HoleID: breakdownRow.hole_id,
        Type: breakdownRow.aob_type,
        TimeStart: breakdownRow.time_start,
        TimeFinish: breakdownRow.time_finish,
        Hours: breakdownRow.total_hours,
        DataSource: aid,
    }];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Breakdown row added to cloud successfully.");
            return true;
        } else {
            console.error("Failed to add activity row to cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in addBreakdownRow API call:", error);
        return false;
    }
};

export const updateBreakdownRow = async (bid: number, updatedRow: ActivityAndBreakdownData) => {
    const apiUrl = getApiUrl(`/api/TitelineBreakdowns/UpdateBreakdownsByBid/${bid}`);

    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        Type: updatedRow.aob_type,
        TimeStart: updatedRow.time_start,
        TimeFinish: updatedRow.time_finish,
        Hours: updatedRow.total_hours,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Activity row with Bid ${bid} updated successfully.`);
            return true;
        } else {
            const errorMessage = await response.text();
            console.error(`Failed to update breakdown row with Bid ${bid}:`, response.status, response.statusText, errorMessage);
            return false;
        }
    } catch (error) {
        console.error("Error in updateBreakdownRow API call:", error);
        return false;
    }
};

export const deleteBreakdownByBid = async (bid: number) => {
    const apiUrl = getApiUrl(`/api/TitelineBreakdowns/DeleteBreakdownsByBid/${bid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteBreakdownsByBid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete breakdown row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteBreakdownsByBid API call:", error);
        return false;
    }
};